<app-pias-layout>
    <div pias-layout-content>
        <div id="dashboard-container" class="container-fluid">
            <div id="dashboard-header" class="d-flex justify-content-between">
                <h5 class="page-header">Dashboard</h5>
                <select id="target-year-select" class="ms-1" [formControl]="targetYearFc">
                    @for(item of targetYearOptions; track item) {
                    <option [value]="item.value">{{item.name}}</option>
                    }
                </select>
            </div>

            <div id="dashboard-tabs-container">
                <mat-card appearance="raised">
                    <mat-card-content>
                        <mat-tab-group (selectedTabChange)="this.__onDashboardTabChange($event)">
                            <mat-tab label="APE" id="ape">
                                <div class="dashboard-tab-content">
                                    <dashboard-ape-v2
                                        [tabState]="{isActive: this.selectedTabId === 'ape', targetYear: this.targetYearFc.value}"></dashboard-ape-v2>
                                </div>
                            </mat-tab>
                            @if(!this.isAffinityUser()) {
                            <mat-tab label="Gross Revenue" id="gross-revenue">
                                <div class="dashboard-tab-content">
                                    <dashboard-gross-revenue-v2
                                        [tabState]="{isActive: this.selectedTabId === 'gross-revenue', targetYear: this.targetYearFc.value}"></dashboard-gross-revenue-v2>
                                </div>
                            </mat-tab>
                            <mat-tab label="Convention" id="convention">
                                <div class="dashboard-tab-content">
                                    <dashboard-pias-convention-v2
                                        [tabState]="{isActive: this.selectedTabId === 'convention', targetYear: this.targetYearFc.value}"></dashboard-pias-convention-v2>
                                </div>
                            </mat-tab>
                            }
                            <mat-tab label="MDRT Status" id="mdrt-status">
                                <div class="dashboard-tab-content">
                                    <dashboard-mdrt-status-v2
                                        [tabState]="{isActive: this.selectedTabId === 'mdrt-status', targetYear: this.targetYearFc.value}"></dashboard-mdrt-status-v2>
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</app-pias-layout>>